import path from 'path'

export const OBJECT_ID = window.location.pathname.split('/')[5] || ''
export const COURSENUM = window.location.pathname.split('/')[3]
const DJANGO_URL = window.location.pathname.split('/').slice(0, 4).join('/')

export let routePaths = {
  root: DJANGO_URL,
  wizard: DJANGO_URL.split('/').slice(0, 3).join('/'),
  design: path.join(DJANGO_URL, 'design', ':id?'),
  requirements: path.join(DJANGO_URL, 'requirements', ':id?'),
  review: path.join(DJANGO_URL, 'review', ':id?'),
}

export let linkPaths = {
  design: path.join(DJANGO_URL, 'design', `${OBJECT_ID}`),
  requirements: path.join(DJANGO_URL, 'requirements', `${OBJECT_ID}`),
  review: path.join(DJANGO_URL, 'review', `${OBJECT_ID}`),
}
